import { ArrowLeftIcon } from "@heroicons/react/24/solid"
import Button from "~/components/ui/Button"
import { useInvoicesPaymentsContext } from "~/contexts/InvoicePaymentsProvider"
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js"
import React, { useState } from "react"
import OrderSummary from "~/components/Admin/Orders/OrderSummary"
import PaymentDisclaimer from "~/components/Invoices/PublicInvoices/PaymentDisclaimer"
import CheckboxWithLabel from "~/components/ui/CheckboxWithLabelForForm"

const CustomerPayments = () => {
  const { handleBackToInvoices, preview, camp, campingStyle, handlePaymentTypeChange, isLoading, paymentMethod, handlePayNow, invoice, isSavingPaymentMethod, isAutoCharging,
    setIsSavingPaymentMethod, setIsAutoCharging } = useInvoicesPaymentsContext()

  const stripe = useStripe()
  const elements = useElements()

  const [isPaymentComplete, setIsPaymentComplete] = useState(false)

  const handlePaymentChange = (event: any) => {
    setIsPaymentComplete(event.complete)

    if (handlePaymentTypeChange) {
      handlePaymentTypeChange(event)
    }
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!stripe || !elements) {
      console.error("Stripe or Elements not loaded")
      return
    }

    handlePayNow(elements)
  }

  const taxRateLabel = campingStyle?.tax_rate ? campingStyle?.tax_rate_label : camp?.tax_rate ? camp?.tax_rate_label : "Tax"

  return (
    <form
      className="mx-auto w-full pb-8 max-w-8xl px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 mt-10"
      onSubmit={handleSubmit}
    >
      <Button className="bg-transparent hover:bg-gray-50" onClick={handleBackToInvoices}>
        <ArrowLeftIcon className="h-6 w-6" />
      </Button>
      <div className="w-full flex flex-col md:flex-row">
        <div className="w-full flex flex-col px-4 py-3" >
          <h2 className="text-xl font-semibold">Payment Information</h2>
          <span className="text-xs text-gray-600 mb-2">Fees will be applied based on the payment method you choose.</span>
          <PaymentElement id="payment-element" data-testid="invoice-stripe-payment" onChange={handlePaymentChange} />
            <CheckboxWithLabel
              label="Save my payment method for future use"
              value={isSavingPaymentMethod}
              required={campingStyle.is_required_save_guest_payment_method}
              setValue={(e) => {
                setIsSavingPaymentMethod(e)
                if (!e) setIsAutoCharging(false)
              }}
              labelClasses="text-md whitespace-nowrap my-2 mt-1"
              data-testid="save-card-checkbox"
              className="mt-1.5"
            />
          {!!invoice?.reservation?.long_term_reservation_id &&
            (!!invoice?.reservation?.camper?.phone || !!invoice?.reservation?.camper?.email) &&
            camp?.is_enabled_auto_charging && (
              <CheckboxWithLabel
                label="Autocharge future payments to this payment method"
                value={isAutoCharging}
                disabled={!isSavingPaymentMethod}
                setValue={setIsAutoCharging}
                labelClasses="text-md whitespace-nowrap"
                data-testid="autocharge-checkbox"
                className="mt-1"
              />
            )}
        </div>
        <div className="w-full flex flex-col px-4 py-3 md:max-w-1/2">
          <h2 className="text-xl font-semibold pb-2.5">Price Details</h2>
          <OrderSummary
            order={preview}
            camp={camp}
            isPreview
            isLoading={isLoading}
            isRecurring={!!invoice?.reservation?.long_term_reservation_id || false}
            taxRateLabel={taxRateLabel}
            isIncludingLineItems
            isGuestView
            isInvoicePage
          />
          <Button
            type="submit"
            variant="blue"
            className="mt-3 hover:transform hover:-translate-y-0.5 transition-transform duration-300"
            data-testid="invoice-button-pay-now"
            disabled={!isPaymentComplete || isLoading}
          >
            Pay now
          </Button>
          {camp && <PaymentDisclaimer camp={camp} />}
        </div>
      </div>
    </form>
  )
}

export default CustomerPayments
